<template>
  <div v-if="categorias">
    <div class="row no-gutters" role="list">
      <div class="col-6 col-lg-4 p-1 mb-1" v-for="(c, index) in categorias" :key="index" role="listitem">
        <router-link :to="url + '/categorias/?id=' + c.id_categoria" class="text-dark cardapio-card bg-white" :class="{icon}">
          <h6 class="text-cardapio">{{c.nome_categoria}}</h6>
          <img class="img-icon" :src="`${base_cdn}/icones/${c.slug || 'default'}.svg`" v-if="icon">
          <imagem-carregavel class="img-cardapio" lazy :src="(c.img_categoria ? c.img_categoria : base_cdn + '/static/imgs/categorias/'+ c.slug +'.png') + randon" :alt="c.nome_categoria"
               aria-hidden="true" v-else-if="c.slug || c.img_categoria" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ImagemCarregavel from "./ImagemCarregavel";
  export default {
    components: {ImagemCarregavel},
    name: "Cardapio",
    props: ['categorias', 'icon'],
    data() {
      return {
        url: '',
        randon: ''
      }
    },

    mounted() {
      const root = this.modo_catalogo ? '' : '/unidade';
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '', root);
    }
  }
</script>

<style scoped>
  .cardapio-card {
    display: block;
    padding: 16px;
    position: relative;
    width: 100%;
    height: 120px;
    overflow: hidden;
    border-radius: 16px;
    color: #fff;
    font-weight: bold;
    box-shadow: var(--shadow);
    transition-duration: .15s;
  }
  .cardapio-card:hover {
    box-shadow: var(--shadow-lg);
    transition-duration: .15s;
  }
  .img-cardapio {
    height: 140px;
    width: 100%;
    position: absolute;
    object-fit: contain;
    bottom: -30%;
    right: -40%;
  }
  .img-cardapio ::v-deep .imagem-skeleton {
    inset: auto;
    top: 0;
    left: 50%;
    width: 140px;
    max-width: 100%;
    height: 140px;
    border-radius: 50%;
    transform: translateX(-50%);
  }
  .text-cardapio {
    font-size: 0.9rem;
    margin: 0;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    height: 20px;
    overflow: hidden;
    font-weight: 500;
  }
  .cardapio-card.icon {
    height: 72px;
  }
  .img-icon {
    padding: 16px;
    background-color: var(--light);
    width: 72px;
    position: absolute;
    object-fit: contain;
    top: 0;
    bottom: 0;
    right: 0;
  }
</style>
